interface PageTitleProps {
  title: string;
  subtitle?: string;
  icon?: string;
  color?: string;
}

export default function PageTitle({ title, subtitle, icon, color }: PageTitleProps) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
      {icon && <span style={{ fontSize: 17, color, lineHeight: "24px", width: 17, textAlign: "center", flexShrink: 0 }}>{icon}</span>}
      <div>
        <h1 style={{ fontSize: 16, lineHeight: "24px", fontWeight: 700, color: "var(--fg)", margin: 0, letterSpacing: "-0.02em" }}>{title}</h1>
        {subtitle && <div style={{ fontSize: 12, color: "var(--fg-muted)", marginTop: 1 }}>{subtitle}</div>}
      </div>
    </div>
  );
}
